module.exports = __webpack_public_path__ + "static/img/side-logo.7d184ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/side-logo.svg
// module id = 2ygy
// module chunks = 65